import { useStaticRoute } from 'shared/library/routes/route';
import { Post, Props } from 'shared/@types';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { Link } from 'shared/components/link';
import { useTranslation } from 'react-i18next';
import { useFormatter } from 'shared/library/use-formatter';
import { memo } from 'react';
import { getPostImage } from 'shared/library/get-model-image';

export const PostCard = memo(function PostCard({ post }: Props<{ post: Post }>) {
  const { t } = useTranslation('components');
  const { formatDateCustom } = useFormatter();
  const route = useStaticRoute();
  const postImage = getPostImage(post) ?? '';

  return (
    <Link href={route('blog.show', { post: post.slug })} asBlock>
      <Image
        src={postImage}
        alt={post.title}
        containerClassName={'aspect-video w-full'}
        imageClassName={'rounded object-cover group-hover:opacity-75'}
        sizeType={'card'}
      />

      <Text
        className={'text-brand-brown-dark mt-3 text-lg font-bold group-hover:underline md:text-xl'}
      >
        {post.title}
      </Text>
      <Text className={'text-brand-brown mt-1.5'} numberOfLines={4}>
        {post.summary}
      </Text>

      <Text className={'text-brand-brown-dark/70 mt-3 text-sm'}>
        {t('post_card.published')} {formatDateCustom(post.published_at!, 'do LLLL yyyy')}
        {' · '}
        {t('post_card.reading_time', { count: post.reading_time })}
      </Text>
    </Link>
  );
});
